import { campaignClient, getErrorMessageFromGraphQlErrors } from '../../../../../apis/graphql';
import type { Asset2, Asset2GQL } from '../../../../../models';
import { transformAsset2GQLToAsset2 } from '../../../../../utils/assets';
import { GET_ASSETS_2_BY_IDS } from '../../queries';

export async function fetchAssetsByIds(
  assetIds: string[],
  lineItemPublishers?: string[],
  countriesList?: string[]
): Promise<Asset2[]> {
  if (!assetIds?.length) return [];

  const { data, errors } = await campaignClient.query({
    query: GET_ASSETS_2_BY_IDS,
    variables: { assetIdList: assetIds },
  });

  if (errors) throw new Error(getErrorMessageFromGraphQlErrors(errors));

  const assets2 = (data?.getAsset2ByIDs as Asset2GQL[]) || [];

  return assets2.map((asset) => transformAsset2GQLToAsset2(asset, lineItemPublishers, countriesList));
}
